import React from 'react';
import { observer } from 'mobx-react';
import { WeaDatePicker } from 'ecCom';

interface Props {
    editable?: boolean;
    value?: string;
    valueSpan?:string;
    onChange: (string) => void;
    column?;
    row?;
}

export default observer((props: Props) => {
    const { column, row,value } = props;
    let hide=column&&column.isHide&&column.isHide(row);
    return (
        <div style={hide?{display:"none"}:{display:"block"}}>
        {props.editable ? 
            <WeaDatePicker ecId={`${this && this.props && this.props.ecId || ''}_WeaDatePicker@syo2pm`} noInput
                    showTime
                    format="yyyy-MM-dd HH:mm"
                    value={value}
                    onChange={v=>{props.onChange&&props.onChange(v);column.onChange&&column.onChange(v,row)}}
                />: <span>{value}</span>}
        </div>
    )
});


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/mobx-table/table-cell/WeaDateTimePicker.tsx